import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { environment } from "../../environments/environment";
import { PaginationFeaturesDto } from "../models/paginationfeaturesdto";
import { EnrollmentModificationDto } from "../models/enrollment/enrollmentModificationDto";
import { EnrollmentCancellationDto } from "../models/enrollment/enrollmentCancellationDto";
import { AppConfigService } from "./core/appConfig.service";

@Injectable({
    providedIn: 'root'
})
export class EnrollmentService {

    constructor(private http: HttpClient, private configService:AppConfigService) { }

    getListEnrollmentModification(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', 'idEnrollmentBehaviorPatternModification')
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/enrollment-modification/listAll?${params}`).pipe(
            map(response => { return response; }));
    }

    getEnrollmentModificationById(idEnrollmentBehaviorPatternModification: number): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/enrollment-modification/listAll/${idEnrollmentBehaviorPatternModification}`;
        return this.http.get<any>(url).pipe(map(response => { return new EnrollmentModificationDto(response); }));
    }

    insertEnrollmentModification(generalDiscount: EnrollmentModificationDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/enrollment-modification/insert`;
        return this.http.post<any>(url, generalDiscount).pipe(
            map(response => {
                return new EnrollmentModificationDto(response);
            })
        );
    }

    updateEnrollmentModification(generalDiscount: EnrollmentModificationDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/enrollment-modification/update/true`;
        return this.http.put<any>(url, generalDiscount).pipe(
            map(response => {
                return new EnrollmentModificationDto(response);
            })
        );
    }

    //CANCELLATION

    getListEnrollmentCancellation(pageRequest: PaginationFeaturesDto): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', '')
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/enrollment-cancellation/listAll?${params}`).pipe(
            map(response => { return response; }));
    }

    getEnrollmentCancellationById(idEnrollmentBehaviorPatternModification: number): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/enrollment-cancellation/listAll/${idEnrollmentBehaviorPatternModification}`;
        return this.http.get<any>(url).pipe(map(response => { return new EnrollmentModificationDto(response); }));
    }

    insertEnrollmentCancellation(generalDiscount: EnrollmentCancellationDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/enrollment-cancellation/insert`;
        return this.http.post<any>(url, generalDiscount).pipe(
            map(response => {
                return new EnrollmentCancellationDto(response);
            })
        );
    }

    updateEnrollmentCancellation(generalDiscount: EnrollmentCancellationDto): Observable<any> {
        const url = `${this.configService.apiUrl}/configuration/enrollment-cancellation/update/true`;
        return this.http.put<any>(url, generalDiscount).pipe(
            map(response => {
                return new EnrollmentCancellationDto(response);
            })
        );
    }


}